 <div id="content-container"> 



<div class="no-print">
  <h3 class="dashpanel-h4">Approve AA and Addendums</h3>
</div> 


<!-- <app-select>

</app-select> -->
 <!-- <div *ngIf="showStep1"> -->
   <div>
  <app-select [hidden]="dontShowStep1" (selectedAA)="childEventClicked($event)" ></app-select>
 </div> 

<!-- <div *ngIf="!showStep1"> -->
  <div>
   <app-complete [hidden]="dontShowStep2" [aaSelected]=restatementDocs (back)="backButtonClicked($event)"></app-complete> 
 </div> 
<!-- 
<div class="row" *ngIf="showStep1"> 
  <div class="col-sm-3">
    <button (click)="navigateToStep2()" class="btn btn-primary">Next</button>
  </div> 
</div> -->
</div>


